export default __webpack_public_path__ + "static/media/down-arrow-blue.b47bf27e.svg";